import { createSlice } from "@reduxjs/toolkit";
import { State } from "store/state";

const initialState = {
  showTaskReviewCount: 0,
  showTasksCount: 0,
  showCartCount: 0,
};

const badgesSlice = createSlice({
  name: "badges",
  initialState,
  reducers: {
    setShowTaskReviewCount: (state, { payload }: { payload: number }) => ({
      ...state,
      showTaskReviewCount: payload,
    }),
    setShowTasksCount: (state, { payload }: { payload: number }) => ({
      ...state,
      showTasksCount: payload,
    }),
    setShowCartCount: (state, { payload }: { payload: number }) => ({
      ...state,
      showCartCount: Number(payload.toFixed(2)),
    }),
  },
});

export const {
  setShowCartCount,
  setShowTasksCount,
  setShowTaskReviewCount,
} = badgesSlice.actions;

export const getBadges = (state: State) => state.badges;

export default badgesSlice.reducer;
